import angular from 'angular';
import {
    IArquivoTrabalhador,
    IArquivoTrabalhadorUploadPayload,
} from '../model/arquivos.trabalhador.service.model';
import { NsjRoutingType } from '@core/nsj-core';

export class MeurhArquivosTrabalhadorService {
    static $inject = ['$http', '$rootScope', '$q', 'nsjRouting'];

    public loading_deferred: angular.IDeferred<unknown>;

    constructor(
        public $http: angular.IHttpService,
        public $rootScope: angular.IScope,
        public $q: angular.IQService,
        public nsjRouting: NsjRoutingType,
    ) { }

    getArquivos(tipoarquivo: string, trabalhador: string) {
        this.loading_deferred = this.$q.defer();
        return this.$q<IArquivoTrabalhador[]>((resolve, reject) => {
            this.$http.get<IArquivoTrabalhador[]>(
                this.nsjRouting.generate('meurh_arquivostrabalhadores_index', {
                    tipoarquivo,
                    trabalhador
                }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('meurh_arquivostrabalhadores_index_loaded', response.data);
                resolve(response.data);
            })
            .catch((error) => reject(error));
        });
    }

    getConteudo(id: string) {
        this.loading_deferred = this.$q.defer();
        return this.$q<angular.IHttpResponse<File>>((resolve, reject) => {
            this.$http.get<File>(
                this.nsjRouting.generate('meurh_arquivostrabalhadores_get_arquivo', {
                    id
                }, true), {
                responseType: 'blob',
                timeout: this.loading_deferred.promise
            })
            .then((response) => {
                this.$rootScope.$broadcast('meurh_arquivostrabalhadores_get_arquivo_loaded', response);
                resolve(response);
            })
            .catch((error) => reject(error));
        });
    }

    downloadArquivos(arquivos: {arquivotrabalhador: string}[]) {
        this.loading_deferred = this.$q.defer();
        return this.$q<File>((resolve, reject) => {
            this.$http.post<File>(
                this.nsjRouting.generate('meurh_arquivostrabalhadores_downloadarquivoslote', {}, true), {
                    entities: angular.copy(arquivos)
                }, {
                responseType: 'blob',
                timeout: this.loading_deferred.promise
            })
            .then((response) => {
                this.$rootScope.$broadcast('meurh_arquivostrabalhadores_downloadarquivoslote_loaded', response);
                resolve(response.data);
            })
            .catch((error) => reject(error));
        });
    }

    liberarArquivo(id: string) {
        this.loading_deferred = this.$q.defer();
        return this.$q<void>((resolve, reject) => {
            this.$http.put<void>(
                this.nsjRouting.generate('meurh_arquivostrabalhadores_liberar', {
                    id
                }, true),
                {},
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('meurh_arquivostrabalhadores_liberar_loaded', response.data);
                resolve(response.data);
            })
            .catch((error) => reject(error));
        });
    }

    uploadArquivo(payload: IArquivoTrabalhadorUploadPayload) {
        this.loading_deferred = this.$q.defer();
        return this.$q<void>((resolve, reject) => {
            this.$http.post<void>(
                this.nsjRouting.generate('meurh_arquivostrabalhadores_insert', {}, true),
                payload,
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('meurh_arquivostrabalhadores_insert_loaded', response);
                resolve(response.data);
            })
            .catch((error) => reject(error));
        });
    }
}
